import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { NftPurchaseContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const CreateMintCategory = () => {

    const { account } = useWeb3React();
    const web3 = useWeb3();
    const tokenAddress = Environment.SmartCityContract;
    const contract = NftPurchaseContract(tokenAddress, web3);


    const CreateMintCategoryHook = useCallback(
        async (_name, _maxMintAmount, _maxSupply, _costPerNft, _uri, _rentAmount) => {

            console.log('payload okokokok', _name, _maxMintAmount, _maxSupply, _costPerNft, _uri, _rentAmount);
  
            try {
                // Contract on BSC has `createMintCategory(...) external onlyOwner`.
                // Avoid prompting a signature that will revert for non-owner wallets.
                const owner = await contract.methods.owner().call();
                if (!owner || owner.toLowerCase() !== account?.toLowerCase()) {
                    throw new Error("Only the contract owner wallet can create a project on-chain.");
                }

                // let gasPrice = await web3.eth.getGasPrice();
                // gasPrice = parseInt(gasPrice) + 5000000000;
                // const gas = await contract.methods.createMintCategory(_name, _maxMintAmount, _maxSupply, _costPerNft, _uri, _rentAmount).estimateGas({
                //     from: account
                // });
                const details = await contract.methods.createMintCategory(_name, _maxMintAmount, _maxSupply, _costPerNft, _uri, _rentAmount).send({
                    from: account,
                    // gas,
                    // gasPrice: gasPrice
                });
                return details;
            } catch (error) {
                console.log(error, "error in white list buy nft");

                throw error;
            }
        },
        [contract, account]
    );
    return { CreateMintCategoryHook: CreateMintCategoryHook };
};
export default CreateMintCategory;